import './_users.scss';
import './_users.dark-mode.scss';
import React, { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Grid, Button } from 'react-bootstrap';
import { useHistory, useLocation } from 'react-router-dom';
import { has } from 'lodash';
import qs from 'qs';

import TableUsers from './components/TableUsers';
import Modal from '../../components/Modal/Default';
import FilterGroup from '../../components/Filters/FilterGroup';
import SearchGroup from '../../components/Search/SearchGroup';
import SearchButton from '../../components/Search/SearchButton';
import Pagination from '../../components/Pagination';
import Totals from '../../components/Totals';
import Form from './components/UserForm';
import Loader from '../../components/Loaders/Loader';

import { getUsersListAction, getUserConfigs, getUsersTotalsAction } from '../../redux/actions/users/general';
import { clearRootStateAction } from '../../redux/actions/root';
import { getUsersListSelector } from '../../redux/selectors/users';
import { getRootStateSelector } from '../../redux/selectors/root';
import { getModal, detectDataValue, getMassAccess } from './helpers';
import { checkValidIP } from '../../utils/helper';

const Users = () => {
  const dispatch = useDispatch();

  const history = useHistory();
  const location = useLocation();

  const ref = useRef(null);

  const userData = useSelector((state) => state.users.userData);

  const queryString = qs.parse(location.search.slice(1));

  const [init, setInit] = useState(false);
  const [userSelected, setSelected] = useState(false);
  const [loading, setLoading] = useState(false);
  const [values, setValues] = useState([]);
  const [ratesValues, setRatesValues] = useState([]);
  const [selectedUsers, setUsers] = useState([]);
  const [open, setOpen] = useState(false);
  const [Settings, setSettings] = useState({ modalText: {}, Form });
  const [key, setKey] = useState(0);
  const [wasAddRates, setWasAddRates] = useState(false);
  const [historySearch, setHistorySearch] = useState('');

  const inc = () => setKey(key + 1);

  const toggle = () => {
    setOpen((prev) => !prev);
  };

  const openModal = (modalIndex, user) => {
    setSelected(false);
    setSettings(getModal(modalIndex, user));
    toggle();
  };

  const actionFetching = useSelector((state) => state.users.actionFetching);
  const { users, pagination, access, config, columns, fields, filters, discounts } = useSelector((state) => getRootStateSelector(state));
  const userState = useSelector((state) => getUsersListSelector(state));
  const { isFetching, ratesFetching, servicesFetching, userRates, totals } = userState;
  const accessMassActions = getMassAccess(config.access);

  const onSearchByIPs = (id) => {
    history.push(`/users?same-ips=${id}`);
  };

  const checkQueryIP = (query) => {
    if (!query) {
      setHistorySearch('');
      return false;
    }
    const splited = query.split(',');
    const isIPs = splited.every((str) => checkValidIP(str.trim()));
    isIPs && setHistorySearch(query);
  };

  const getAllpageData = async () => {
    setValues([]);
    setLoading(true);
    checkQueryIP(queryString?.query);

    try {
      const response = await Promise.all([dispatch(getUserConfigs()), dispatch(getUsersListAction(queryString))]);
      const configResponse = response?.[0];
      if (configResponse?.success && configResponse?.data?.access?.users_totals) {
        await dispatch(getUsersTotalsAction());
      }
      !init && setInit(true);
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  useEffect(() => {
    getAllpageData();
    document.title = 'Users';
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, location.search, key]);

  useEffect(
    () => () => {
      dispatch(clearRootStateAction());
    },
    [dispatch],
  );

  useEffect(() => {
    if (has(queryString, 'same-ips')) {
      setHistorySearch(filters?.query || '');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filters, location.search]);

  return (
    <Grid fluid>
      <Modal bsSize={Settings.size}>
        <Settings.Form
          config={config}
          isFetching={actionFetching}
          isDisabled={userSelected}
          selectedUsers={selectedUsers}
          setValues={setValues}
          setUsers={setUsers}
          ratesValues={ratesValues}
          setRatesValues={setRatesValues}
          setWasAddRates={setWasAddRates}
          showCloseButton
          toggle={toggle}
          values={values}
          formRef={ref}
          fields={fields}
          open={open}
          userData={userData}
          setSelected={setSelected}
          isData={Settings.forAddRates && detectDataValue(userRates, ratesValues, wasAddRates)}
          modalHoverLoader={ratesFetching || servicesFetching || actionFetching}
          forAddRates={Settings.forAddRates}
          forEditUser={Settings.forEditUser}
          ratesFetching={ratesFetching}
          clearValue={() => setRatesValues([])}
          setOpen={setOpen}
          historySearch={historySearch}
          {...Settings}
        />
      </Modal>

      <FilterGroup>
        {config.access?.create_user && (
          <Button onClick={() => openModal(1)} className="pull-left">
            Add user
          </Button>
        )}
        <SearchGroup autocomplete="on" sectionName="users" placeholder="Search" withClear filters={filters} />
        {config.access?.export_list && <SearchButton onClickButton={() => history.push('/users/export')} buttonText="Export" />}
      </FilterGroup>
      {(loading || isFetching) && !init ? (
        <Loader />
      ) : (
        <>
          {access?.list && (
            <>
              {config?.access?.users_totals && (
                <Totals
                  styles={{ marginTop: '-12px', marginBottom: '6px' }}
                  content={(
                    <ul className="users-totals">
                      <li className="users-totals__item">
                        <span className="item-title">Total user balance</span>
                        <span>{totals?.balance}</span>
                      </li>
                      <li className="users-totals__item">
                        <span className="item-title">Total user spent</span>
                        <span>{totals?.spent}</span>
                      </li>
                    </ul>
                  )}
                />
              )}

              <TableUsers
                filters={filters}
                isLoading={loading || isFetching}
                setValues={setValues}
                values={values}
                setUsers={setUsers}
                access={access}
                users={users}
                accessMassActions={accessMassActions}
                statuses={config?.statuses}
                levels={discounts}
                fields={fields}
                columns={columns}
                openModal={openModal}
                inc={inc}
                config={config}
                historySearch={historySearch}
                onSearchByIPs={onSearchByIPs}
              />
              <Pagination
                pages={pagination?.pages}
                currentPage={pagination?.current_page}
                itemsCount={pagination?.total_count}
                pageSize={pagination?.page_size}
                pagesLimit={pagination?.pages < 10 ? pagination?.pages : 10}
              />
            </>
          )}
        </>
      )}
    </Grid>
  );
};

export default Users;
